import PropTypes from 'prop-types';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import './DetailTicketKnowledge.css';

import { useState, useEffect, useMemo } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';

import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { multiPanelAtom, closeTabId, panelInitDataAtom } from '@/state/atom/panelAtom';
import { setPanelSelector, closePanelTabSelector, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import {
    getListActiveB2BCustomerSelector,
    getListActiveB2BHelpdeskSelector
} from '@/state/selector/ticketSelector';
import {
    triggerReLoadKnowledgeTicketDetailAtom
} from '@/state/atom/ticketKnowledgeAtom';

import { Tooltip } from '@material-ui/core';
import LoadingPanel from '../common/LoadingPanel';

import {
    handleInitPdfTicketDetail,
    getPanelType,
    handleConfirmAccessDenied,
    isShowExtractedTextAndVectorDataInFileAndPageKnowledge,
    isDisplayExtractText,
    isDisplayVectorUrlAndTotalToken,
    handleOpenTicketDetail
} from './handler/DetailTicketHandler';
import RenderFieldPDFKnowledge from './elements/RenderFieldPDFKnowledge';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import Bookmark from './elements/Bookmark/Bookmark';
import TagDefaultBookmark from './elements/Bookmark/TagDefaultBookmark';
import UserTagPrivateBookmarkCount from './elements/Bookmark/UserTagPrivateBookmarkCount';
import TaggedBookmarkListName from './elements/Bookmark/TaggedBookmarkListName';
import CopyShortLink  from '@/component/ticketKnowledge/elements/CopyShortLink';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';

DetailTicketPDFKnowledge.propTypes = {
    API: PropTypes.any,
    ticketId: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    triggerReload: PropTypes.any,
    isCustomer: PropTypes.any,
};

function DetailTicketPDFKnowledge(props) {
    const [isLoading, setIsLoading] = useState(false);
    //ticket state
    const [detailTicket, setDetailTicket] = useState({});
    const [settingTitleLineNumber, setSettingTitleLineNumber] = useState(0);
    const [ticketOutline, setTicketOutline] = useState('');
    const [corporationAffiliationTicket, setCorporationAffiliationTicket] = useState({});
    const [fieldListDefaultData, setFieldListDefaultData] = useState([]);
    const [hasEditSettingPermissions, setHasEditSettingPermissions] = useState(false);
    const [hasEditFieldPermissions, setHasEditFieldPermissions] = useState(false);

    const [isShowExtractedText, setIsShowExtractedText] = useState(false);

    // atom
    const corporationDetail = useRecoilValue(corporationAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const currentUserDetail = useRecoilValue(userAtom);

    const isGeneralUser = Utils.isGeneralUser(currentUserDetail);
    const listB2BCustomer = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpdesk = useRecoilValue(getListActiveB2BHelpdeskSelector);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [triggerReLoadKnowledgeTicketDetail, setTriggerReLoadKnowledgeTicketDetail] = useRecoilState(
        triggerReLoadKnowledgeTicketDetailAtom
    );

    //dialog
    const [isShowPopupReloadPage, setIsShowPopupReloadPage] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    
    const [formDetail, setFormDetail] = useState({});

    const argsAll = {
        ...props,
        API: props?.API,
        ticketId: props.ticketId,
        panelId: props.panelId,
        tabId: props.tabId,
        triggerReload: props.triggerReload ? {} : panelInitData,
        setIsLoading,
        setDetailTicket,
        setSettingTitleLineNumber,
        setTicketOutline,
        setCorporationAffiliationTicket,
        setPanelInitData,
        panelList,
        setPanelList,
        setSettingTitle: () => {},
        setFieldListDefaultData,
        setHasEditSettingPermissions,
        setHasEditFieldPermissions,
        listB2BCustomer,
        listB2BHelpdesk,
        projectInuseDetail,
        currentUserDetail,
        corporationDetail,
        setIsOpenAccessDeniedPopup,
        setIsShowPopupReloadPage,
        setIsOpenModalReloadPage,
        addNewPanel,
        isCustomer: props.isCustomer,
        formDetail,
        setFormDetail,
        setTriggerReLoadKnowledgeTicketDetail
    };

    // handle get init ticketDetail
    useEffect(() => {
        handleInitPdfTicketDetail(argsAll);
    }, []);

    // handle get init ticketDetail when have trigger reload
    useEffect(() => {
        if (
            props.triggerReload ||
            triggerReLoadKnowledgeTicketDetail === detailTicket.id
        ) {
            handleInitPdfTicketDetail(argsAll);
            setTriggerReLoadKnowledgeTicketDetail('')
        }
    }, [props.triggerReload, triggerReLoadKnowledgeTicketDetail])

    // closeTab
    useEffect(() => {
        if (props.tabId === closeTabIdState || closeTabIdState === detailTicket.id) {
            closePanelTab({
                event: null,
                panelType: getPanelType({ panelId: props.panelId, panelList }),
                panelId: props.panelId,
                tabId: detailTicket.id
            });
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    const bookmarkTargetType = useMemo(() => {
        return Utils.getBookmarkTargetTypeByTicketType(detailTicket?.ticketType);
    }, [detailTicket]);

    return (
        <div style={{ height: '100%' }}>
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <div className="mainWrap file-page-knowledge-body">
                    <div className="scrollBar-main detailTicketKnowledge flex-column">
                        {/* Ticket header */}
                        <div className='ticket-pdf-header-wrap'>
                            <div className="titleTicket title-ticket-knowledge ticket-pdf-inner">
                                {/* Bookmark */}
                                <TagDefaultBookmark
                                    className={'ticket-knowledge-detail-tag-default'}
                                    isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                    ticketKnowledge={detailTicket}
                                    corporationDetail={corporationDetail}
                                    projectInuseDetail={projectInuseDetail}
                                    userDetail={currentUserDetail}
                                    setTriggerReloadKnowledgeListPanel={reloadTicketListByPanelType}
                                    bookmarkTargetType={bookmarkTargetType}
                                />

                                {/* Ticket Title */}
                                {settingTitleLineNumber === 2 ? (
                                    <label className="titleDisplay titleTicket-titlev2 title-knowledge-display">
                                        {ticketOutline || '[概要 (現在未記入)]'}
                                    </label>
                                ) : (
                                    <Tooltip
                                        title={ticketOutline || '[概要 (現在未記入)]'}
                                    >
                                        <label className="titleDisplay titleTicket-titlev2 title-clamp title-knowledge-display">
                                            {ticketOutline || '[概要 (現在未記入)]'}
                                        </label>
                                    </Tooltip>
                                )}

                                <div className="titleTicket-btn btn-copy-link">
                                    {!Utils.isEmptyObject(detailTicket?.dataShareLink) && (
                                        <CopyShortLink
                                            detailTicket={detailTicket}
                                            isGeneralUser={isGeneralUser}
                                            corporationDetail={corporationAffiliationTicket}
                                        />
                                    )}
                                </div>
                            </div>
                            
                            {/* Bookmark */}
                            <div className='ticket-bookmark-info'>
                                <Bookmark
                                    isTicketBookmark={true}
                                    isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                    ticketKnowledge={detailTicket}
                                    panelType={Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL}
                                    isShowEdit={true}
                                    bookmarkPopupContainerClassName={'reset-position-bookmark-popup-container'}
                                />
                                <div className='ticket-bookmark-info-wrap'>
                                    <div className='ticket-bookmark-info-text-wrap'>
                                        <TaggedBookmarkListName bookmarkListText={detailTicket?.bookmarkListText} className="ticket-bookmark-info-text" />
                                    </div>
                                    <UserTagPrivateBookmarkCount ticketKnowledge={detailTicket}/>
                                </div>
                            </div>
                        </div>

                        {/* Ticket body */}
                        <div className="detail-ticket-body">
                            {/* Detailet ticket field */}
                            <div className="detail-ticket-contents">
                                {fieldListDefaultData.length > 0 &&
                                    fieldListDefaultData
                                        .filter(
                                            field =>
                                                ![
                                                    'ticketType',
                                                    'parent',
                                                    'children',
                                                    'attachment'
                                                ].includes(field.sysField)
                                        )
                                        .map(field => (
                                            <RenderFieldPDFKnowledge
                                                fieldData={field}
                                                key={field.id}
                                                props={argsAll}
                                            />
                                        ))}
                            </div>
                            <div className="detail-ticket-contents">
                                {fieldListDefaultData.length > 0 &&
                                    fieldListDefaultData
                                        .filter(field =>
                                            [
                                                'parent',
                                                // 'children', out of scope
                                                'attachment'
                                            ].includes(field.sysField)
                                        )
                                        .map(field => (
                                            <RenderFieldPDFKnowledge
                                                fieldData={field}
                                                key={field.id}
                                                ticketType={detailTicket.ticketType}
                                                onOpenTicket={handleOpenTicketDetail}
                                                props={argsAll}
                                            />
                                        ))}
                            </div>

                            {/* Detail ticket setting */}
                            {isShowExtractedText &&
                                isShowExtractedTextAndVectorDataInFileAndPageKnowledge(
                                    corporationAffiliationTicket,
                                    hasEditSettingPermissions,
                                    hasEditFieldPermissions
                                ) && (
                                    <div className="setting-ticket-body">
                                        <div className="setting-ticket-item">
                                            <span>{I18n.get('CM-LABEL-SYSTEM-ITEMS')}</span>
                                        </div>
                                        {isDisplayExtractText(
                                            corporationAffiliationTicket,
                                            props.tabId
                                        ) && (
                                            <div className="setting-ticket-item">
                                                <span>
                                                    {I18n.get('HYPERLINK-EXTRACT-TEXT')}
                                                </span>
                                                <a
                                                    className="ticket-redirect"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={detailTicket?.extractTextUrl}
                                                >
                                                    {detailTicket?.extractTextUrl || ''}
                                                </a>
                                            </div>
                                        )}

                                        {
                                            (
                                                isDisplayVectorUrlAndTotalToken(corporationAffiliationTicket,props.tabId) &&
                                                Number(detailTicket.ticketType) === Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE
                                            ) && (
                                                <>
                                                    <div className="setting-ticket-item">
                                                        <span>
                                                            {I18n.get('HYPERLINK-VECTOR-DATA')}
                                                        </span>
                                                        <a
                                                            className="ticket-redirect"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={detailTicket?.vectorDataUrl}
                                                        >
                                                            {detailTicket?.vectorDataUrl || ''}
                                                        </a>
                                                    </div>

                                                    <div className="setting-ticket-item">
                                                        <span>
                                                            {I18n.get('CM-LABEL-TOKEN-NUMBER')}
                                                        </span>
                                                        <span>{detailTicket?.totalToken}</span>
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                )}
                        </div>

                        {/* Ticket footer */}
                        <div className="detail-ticketKnowledge-info">
                            <div className="detailTicket-footer">
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-form">
                                        <div className="detail-ticketKnowledge-form-label">
                                            {I18n.get('LABEL-FORMAT-NAME')}
                                        </div>
                                        <OverFlowTooltipWithTabsMui value={detailTicket?.usingFormName} />
                                    </div>
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-form">
                                        {I18n.get('CM-LABEL-FORMAT-ID')} :
                                        <button
                                            className="id-detail-ticket-copy btn-reset-default"
                                            onClick={async () => {
                                                navigator.clipboard
                                                    .writeText(formDetail?.id)
                                                    .then(() => {})
                                                    .catch(err => {});
                                            }}
                                        >
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </button>
                                        <span className="field-form-id">{formDetail?.id}</span>
                                    </div>
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        投稿日時：<span>{detailTicket?.createTime}</span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        投稿ユーザー： <span>{detailTicket?.createrUserName}</span>
                                    </div>
                                </div>

                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        更新日時：<span>{detailTicket?.updatedTime}</span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        更新ユーザー： <span>{detailTicket?.updatorUserName}</span>
                                    </div>
                                </div>
                                <div className="id-detail-ticket-footer">
                                    {isShowExtractedTextAndVectorDataInFileAndPageKnowledge(
                                        corporationAffiliationTicket,
                                        hasEditSettingPermissions,
                                        hasEditFieldPermissions
                                    ) &&
                                        !isShowExtractedText && (
                                            <button
                                                className={`
                                                    btn-reset-default 
                                                    ${
                                                        isShowExtractedText
                                                            ? 'show-extract-text-btn hidden'
                                                            : 'show-extract-text-btn'
                                                    }
                                                `}
                                                onClick={e => setIsShowExtractedText(true)}
                                            >
                                                詳細
                                            </button>
                                        )}
                                    <div className="footer-ticket-id-data">
                                        <span className="id-detail-ticket-title">
                                            {I18n.get('USER04LB004')} :
                                        </span>
                                        <button
                                            className="id-detail-ticket-copy btn-reset-default"
                                            onClick={async () => {
                                                navigator.clipboard
                                                    .writeText(detailTicket?.id)
                                                    .then(() => {})
                                                    .catch(e =>
                                                        console.log('copy ticketId e :>> ', e)
                                                    );
                                            }}
                                        >
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </button>
                                        <span id="ticketId">{detailTicket?.id}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Dialog */}
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={() => handleConfirmAccessDenied(setIsOpenAccessDeniedPopup)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />

            {/* reload page  */}
            <ConfirmDialog
                isOpen={isShowPopupReloadPage}
                okCallBack={() => window.location.reload()}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
            />
            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
        </div>
    );
}

export default DetailTicketPDFKnowledge;
